module.exports = __webpack_public_path__ + "assets/img/tow.eb0e73d2.png";